import { FC } from "react";
import FlightSelectContent from "../../FlightSelectContent/FlightSelectContent";

const OriginComponentWeb: FC<any> = ({ icon: Icon, hasError, ...props }) => {
  return (
    <div className="text-font-minimal! flex w-full flex-1 items-center gap-1 px-1 md:w-auto">
      <div className={hasError ? "text-font-danger" : "text-font-minimal!"}>
        <Icon className="h-4! w-4!" />
      </div>
      <FlightSelectContent icon={Icon} {...props} />
    </div>
  );
};

export default OriginComponentWeb;
